// One place an error is told to PostHog (error tracking). Every boundary and
// every error page calls this, so a trip is something we see rather than
// something a person has to tell us about. It lives apart from the boundary
// component so a page-level error file can report without importing a class.

import posthog from "posthog-js";

export function reportClientError(error: unknown, where: string, extra?: Record<string, unknown>) {
  try {
    posthog.captureException(error, { where, ...(extra ?? {}) });
  } catch {
    /* analytics must never throw on top of an error */
  }
}
